var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.isLoading
    ? _c(
        "div",
        { class: ["app", { "-warn-explorer": _vm.warnIE && _vm.isDesktop }] },
        [
          _c(
            "transition",
            { attrs: { name: "slide-fade" } },
            [
              _vm.warnIE && _vm.isDesktop
                ? _c("ie-warning", {
                    on: {
                      close: function($event) {
                        _vm.warnIE = false
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c("router-view", { attrs: { "warn-explorer": _vm.warnIE } }),
          _vm._v(" "),
          _c("c-feedback", {
            attrs: {
              type: _vm.feedback.type,
              title: _vm.feedback.title,
              text: _vm.feedback.text,
              icon: _vm.feedback.icon
            },
            on: { close: _vm.closeFeedback }
          })
        ],
        1
      )
    : _c(
        "div",
        { staticClass: "loading-screen" },
        [
          _vm.isLoading ? _c("c-spinner") : _vm._e(),
          _vm._v(" "),
          _vm.isLoading && _vm.showLoadingMessage
            ? _c("div", [
                _c("h1", [_vm._v("Aguarde")]),
                _vm._v(" "),
                _c("h4", [_vm._v("Estamos preparando o seu clube")])
              ])
            : _vm._e()
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"img":"src","image":"xlink:href","cimage":"placeholder","c-image":"placeholder","CImage":"placeholder"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1833
// module chunks = 1610